import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	recentHeading: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	timeAgo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	today: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	yesterday: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thisWeek: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thisMonth: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreThanAMonth: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recentHeading: {
		id: 'nav-platform-integration.sidebar.common.ui.recent.heading',
		description: 'Label for the heading of the fallback component',
		defaultMessage: 'Recent',
	},
	timeAgo: {
		id: 'nav-platform-integration.sidebar.common.ui.recent.time-ago',
		defaultMessage: '{timeAgo} ago',
		description:
			"Label telling user that jira item was last accessed 'timeAgo' ago (such as 5 hours ago)",
	},
	today: {
		id: 'nav-platform-integration.sidebar.common.ui.recent.today-group',
		defaultMessage: 'Today',
		description: 'Label for the group of items that were accessed today',
	},
	yesterday: {
		id: 'nav-platform-integration.sidebar.common.ui.recent.yesterday-group',
		defaultMessage: 'Yesterday',
		description: 'Label for the group of items that were accessed yesterday',
	},
	thisWeek: {
		id: 'nav-platform-integration.sidebar.common.ui.recent.this-week-group',
		defaultMessage: 'This week',
		description: 'Label for the group of items that were accessed this week',
	},
	thisMonth: {
		id: 'nav-platform-integration.sidebar.common.ui.recent.this-month-group',
		defaultMessage: 'This month',
		description: 'Label for the group of items that were accessed this month',
	},
	moreThanAMonth: {
		id: 'nav-platform-integration.sidebar.common.ui.recent.more-than-a-month-group',
		defaultMessage: 'More than a month',
		description: 'Label for the group of items that were accessed more than a month ago',
	},
	loadMore: {
		id: 'nav-platform-integration.sidebar.common.ui.recent.load-more',
		defaultMessage: 'Load more',
		description: 'Label for the button to load more recent items',
	},
});
